<section class="organizationSwitcher">
    @if (organizations()) {
        <button class="resetStyles organizationSelected" (click)="openSwitcher()">
            @if (!selectedOrganizationState()) {
                <div class="wrapper">
                    <span>{{ placeholder }}</span>
                </div>
            }
            @if (selectedOrganizationState()) {
                <div class="wrapper">
                    <app-organization-item
                        [organization]="selectedOrganizationState()"
                        [orgNameTooltipPosition]="selectedOrganizationTooltipPosition"
                    ></app-organization-item>
                    <div class="icon" [innerHTML]="nextArrow"></div>
                </div>
            }
        </button>
        @if (opened()) {
            <div
                class="panelWrapper"
                cdkTrapFocus
                cdkTrapFocusAutoCapture
                [ngClass]="{ opened: opened(), closed: !opened() }"
            >
                <div
                    class="panelContent"
                    [ngClass]="{ opened: opened(), closed: !opened(), toggleSideNav: sideNavService.isOpen() }"
                >
                    <div class="panelHeader">
                        <h2>Select Organization</h2>
                        <button class="buttonClose" (click)="closeSwitcher()">
                            <div class="iconClose" [innerHTML]="close"></div>
                        </button>
                    </div>
                    <div class="panelBody">
                        <ul class="organizationItems">
                            @for (organization of organizations(); track organization.id) {
                                <li>
                                    <button
                                        class="organizationItem"
                                        [ngClass]="{ selected: organization === selectedOrganizationState() }"
                                        (click)="selectItem(organization)"
                                        (keyup)="keyup($event, organization)"
                                        tabindex="0"
                                    >
                                        <app-organization-item [organization]="organization"></app-organization-item>
                                    </button>
                                </li>
                            }
                        </ul>
                    </div>
                </div>
            </div>
        }
    }
</section>
